export const MOCK_PIX_TRANSFER_RECEIPT = {
  amount: 250.75,
  date: "2025-06-17T14:32:00.000Z",
  type: "",
  supportPhone: "0800 000 0000",
  details: [
    {
      value: "Origem",
      items: [
        {
          title: "Nome",
          value: "VALUT ASSETS MANAGEMENT LTDA.",
        },
        {
          title: "Documento",
          value: "**.***.***0/0001-**",
        },
        {
          title: "Conta",
          value: "Conta investimento",
        },
      ],
    },
    {
      value: "Destino",
      items: [
        { title: "Tipo", value: "Chave Pix (CPF)" },
        { title: "Banco", value: "Nu Pagamentos S.A." },
        { title: "Agência", value: "0001" },
        {
          title: "Recebedor",
          value: "Leandro Henrique da Silva Abade",
        },
        {
          title: "Documento do recebedor",
          value: "**.***.***-**",
        },
      ],
    },
    {
      value: "Identificação",
      items: [
        {
          title: "ID da transação",
          value: "E12345678202506171432abcdef12345678",
        },
        {
          title: "Autenticação",
          value: "a1b2c3d4e5f6789012345678901234567890abcd",
        },
      ],
    },
  ],
};

export const MOCK_PIX_TRANSFER_BALANCE = "R$ 12.345,67";
